import zbWithdrawal from './withdrawal.vue'

export default zbWithdrawal
